import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=55bbbf2f&"
import script from "./UserGroupForm.vue?vue&type=script&lang=ts&"
export * from "./UserGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports